<div class="frame">
  <div #container class="container">
    <div class="innerLogin fadeInClass06">
      @if (userRemoteReg) {
        <div  class="text1">Register remotely</div>
        <br/>
        <div  class="text2">Registration code: </div>

        <div class="code-display">
          <div class="digit" *ngFor="let digit of codeDigits">
            {{digit}}
          </div>
        </div>


        <br/>
        <div  class="instructions">In <b>SignStudio</b>, click on 'register SignPlayer', then copy the displayed registration code to complete the registration process.</div>
        <br/>
        <span (click)="userRemoteReg=false" class="clickable-text">register manually</span>
      }
      @if (!userRemoteReg) {
        <div  class="text1">Register manually</div>
        <br/>
        <mat-form-field>
            <input #user (keydown.enter)="passFocusSecondPass()" type="text" placeholder="user" autocomplete="off"
                   matInput [disabled]="blockUI" value="" class="item">
        </mat-form-field>
        <br/>
        <mat-form-field>
            <input #password (keydown.enter)="onClick()" placeholder="password" autocomplete="off" type="password"
                   matInput [disabled]="blockUI" value="" class="item">
        </mat-form-field>
        <br/>
        <div style="text-align: center">
          <button mat-raised-button #btnLogin
              [disabled]="blockUI || password.value.length < 3 || user.value.length < 3" type="button"
              class="buttonStart" (click)="onClick()">
            <span style="position: relative; top: -4px">login</span>
            <mat-icon>login</mat-icon>
          </button>
        </div>
        <span (click)="userRemoteReg=true" class="clickable-text">register remotely</span>
      }
    </div>
  </div>
</div>
<ng-template let-modal #popup>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<!--        <mat-icon class="labelStyle pull-right">desktop_mac</mat-icon>-->
        <div style="color: white; position: relative; top: 13px" class="move labelStyle pull-right dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div class="modal-body" style="padding: 10px">
        <label class="labelStyle ver">Wrong credentials, please try again...</label>
        <hr/>
        <label class="labelStyle ver"></label>
        <td><label class="labelStyle"></label></td>
        <button mat-raised-button class="infoButton buttonStart" type="button" (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
    </div>
</ng-template>
